import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalHeader } from 'reactstrap';
import AppModal from '../../../components/Modal';
export const PickerModal = ({ children, onToggleModal }) => {
    const { t } = useTranslation();
    return _jsx(AppModal, { children: _jsxs(Modal, { isOpen: true, toggle: onToggleModal, modalClassName: 'repositories-modal', contentClassName: 'repositories-modal__content', children: [_jsx(ModalHeader, { toggle: onToggleModal, children: t('selectRepositories') }), children] }) });
};
